import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-grid" }
const _hoisted_2 = { class: "util--screen-reader" }
const _hoisted_3 = { class: "content-grid content-grid--triple content-grid--triple-small-right" }

import Card from '@/components/layout/Card.vue';
import BtnLink from '@/components/layout/BtnLink.vue';
import {DocumentCategoryHelper} from "@/types";
import {useI18n} from "vue3-i18n";
import {computed, onMounted, ref} from "vue";
import DocumentsTable from '@/components/tables/DocumentsTable.vue';
import {useDocumentService} from "@/inversify.config";
import {Document} from "@/types/entities/document";


export default /*#__PURE__*/_defineComponent({
  __name: 'CopropertyIndex',
  setup(__props) {

const {t} = useI18n()

const documentService = useDocumentService();

const recentDocuments = ref<Document[]>([]);
const favoriteDocuments = ref<Document[]>([]);
const documentsAreLoading = ref(false)

const documentCategoryLabelsAndSlugs = computed(() =>
  DocumentCategoryHelper.categoriesLabelAndSlug().sort((a, b) => a.label > b.label ? 1 : -1))

onMounted(async () => {
  await loadAllDocuments()
})

async function loadAllDocuments() {
  documentsAreLoading.value = true;
  recentDocuments.value = [];
  favoriteDocuments.value = [];

  let documents = await documentService.getAllDocuments();
  if (documents && documents.length > 0) {
    recentDocuments.value = documents
      .sort((a: any, b: any) => Date.parse(b.creationDate) - Date.parse(a.creationDate))
    favoriteDocuments.value = documents.filter((x: Document) => x.favoriteDocumentId != null)
  }
  documentsAreLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("routes.coproperty.name")), 1),
    _createVNode(Card, {
      title: _unref(t)('global.quickLinks'),
      class: "card--row-content"
    }, {
      default: _withCtx(() => [
        _createVNode(BtnLink, {
          name: _unref(t)('routes.coproperty.children.addDocument.name'),
          path: { 'name': 'coproperty.children.addDocument' }
        }, null, 8, ["name", "path"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Card, {
        title: _unref(t)('coproperty.recentDocs')
      }, {
        default: _withCtx(() => [
          _createVNode(DocumentsTable, {
            documents: recentDocuments.value,
            "is-loading": documentsAreLoading.value,
            onDocumentsUpdated: loadAllDocuments
          }, null, 8, ["documents", "is-loading"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(Card, {
        title: _unref(t)('coproperty.allDocs')
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentCategoryLabelsAndSlugs.value, (documentCategory) => {
            return (_openBlock(), _createBlock(BtnLink, {
              key: documentCategory,
              name: documentCategory.label,
              path: { 'name': 'coproperty.children.documentCategory', 'params': { 'documentCategorySlug': documentCategory.slug } }
            }, null, 8, ["name", "path"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(Card, {
        title: _unref(t)('coproperty.favoriteDocs')
      }, {
        default: _withCtx(() => [
          _createVNode(DocumentsTable, {
            documents: favoriteDocuments.value,
            "is-loading": documentsAreLoading.value,
            onDocumentsUpdated: loadAllDocuments
          }, null, 8, ["documents", "is-loading"])
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}
}

})